import React, { Fragment } from 'react';
import { useRef } from 'react';
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination,Chip, Select, MenuItem, Button} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import {useGetofficesQuery} from '../../features/offices/officesApiSlice';
import { useAddNewofficetypeMutation, useDeleteofficetypeMutation, useGetofficetypeQuery, useUpdateofficetypeMutation } from '../../features/officetype/officetypeApiSlice';
import { useGetdesignationsQuery } from '../../features/designations/designationApiSlice';
import {useGetUserChangesQuery} from '../../features/userchanges/userchangesApiSlice';
import {useAddBulkUserMutation, useAddNewUserMutation, useDeleteUserMutation, useGetUsersQuery, useUpdateUserMutation} from '../../features/users/usersApiSlice';
import DownloadIcon from '@mui/icons-material/Download';
 import moment from "moment";
import useAuth from '../../features/hooks/useAuth';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ExcelDownload from '../../data/exceldownload';
import nameStringFn from '../../data/nameStringFn';
import {TableContStyle, TableHeadStyle } from '../../Styles/TableStyles';
import {HeadingWrap, Span, CommonButton } from '../../Styles/CommonStyles';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;




const Container = styled.div`
max-width: 100%;
overflow-y: auto;

`

const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
  margin-top:15px;
`
const Button1Div =styled.div`  

`
const Button2Div =styled.div`  

`
const ComplaintCategoryWrapper =styled.div`
  display: flex;
  justify-content:flex-end;
`

const cadreArray = ["CWES-GrA", "CWES-GrB", "Hydromet", "Scientific","Others"];

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};



// const filterFunction =  (array, rolesArray, rolesObject ) =>{
//   let tempArray = structuredClone(array);
//   if(rolesArray.includes("admin") || rolesArray.includes("usereditor")){
//     return array;
//   }
//   let combinedDesigArray = []
//   for(let key in rolesObject){
//     if(rolesArray.includes(key)){
//       console.log(rolesObject[key])
//       combinedDesigArray = combinedDesigArray.concat(rolesObject[key]);
//       console.log(combinedDesigArray)
//     }
//     console.log(combinedDesigArray)
//   }
//   console.log(tempArray.filter(x => combinedDesigArray.includes(x.designation)))
//   return tempArray.filter(x => combinedDesigArray.includes(x.designation));
// }

export default function UserChanges() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const Auth = useAuth();



  const {users} =  useGetUsersQuery("UsersList", {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })

  const {offices} =  useGetofficesQuery("OffList", {
    selectFromResult: ({ data }) => ({
      offices: data?.entities
    }),
  })

  const {designations} = useGetdesignationsQuery("designations", {
    selectFromResult: ({ data }) => ({
      designations: data?.entities
    }),
  })

  const {userchanges} = useGetUserChangesQuery("userchanges", {
    selectFromResult: ({ data }) => ({
      userchanges: data?.entities
    }),
  })

  const [tabledata, setTabledata]= useState([]);
  const [open, setOpen] = useState(false);  
  const [editmodalopen, setEditmodalopen] = useState(false);
  const [addmodalopen, setAddModalOpen] = useState(false);
  const [searchData, setSearchData] = useState({
    email:"",
    name:"",
    designation:[],
    office:[],
    cadre:[],

  });

  const [downloadData, setDownloadData] = useState({});

  const [changeObj, setChangeObj]= useState(); 
  const [editCategory, setEditCategory]=useState(null);
 

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  console.log(searchData)

  const tableCellFont = window.screen.width > 1900? 18:15;
 

  const handleClose = () => {
    setOpen(false);
  };

  const handleEditModalClose = (e) => {
    setEditmodalopen(false);
  }

  const handleAddUserModalClose =() =>{
   setAddModalOpen(false);

  }  



  // const onClickEdit = (e,k,row)=>{
  //   setEditmodalopen(true)
  //   setEditModaldata(row)
  //   setEditCategory(k+1);
  //   console.log(new Date(row.dob))
  // }


  // const onChangeEditdata = (event, newValue, name) =>{
  //   let editModaldataTemp =structuredClone(editModaldata)
  //   if(event?.target?.name){
  //     setEditModaldata({...editModaldataTemp, [event.target.name]:event.target.value});
  //     return
  //   }
  //   if(event.$d){
  //     console.log(event.$d.toISOString())
  //     setEditModaldata({...editModaldataTemp, [name]:event.$d.toISOString()});
  //   }else{
  //     setEditModaldata({...editModaldataTemp, [name]:newValue});  
  //   } 
  // }

  // const onChangeAddUser =(event, newValue, name) =>{

  //   let addModaldataTemp =structuredClone(addModaldata)
  //   if(event?.target?.name){
  //    setAddModaldata({...addModaldataTemp, [event.target.name]:event.target.value});
  //     return
  //   }
  //   if(event.$d){
  //     setAddModaldata({...addModaldataTemp, [name]:event.$d.toISOString()});
  //   }else{
  //     setAddModaldata({...addModaldataTemp, [name]:newValue});  
  //   } 

  // }

  // const handleEditFormSubmit = async (e) =>{
  //   e.preventDefault();
  //   try{ 
  //   const {_id, ...body} = editModaldata; 
  //   const response = await updateUser(body);
  //   setEditModaldata({});
  //   alert(`User ${body.name} with emailId ${body.email} has been edited successfully`)
  //   setEditmodalopen(false);

  //   }catch(err){
  //     console.error("Error occurred while updating user:", err);
  //   }
  // }
  // const handleAddFormSubmit = async (e) =>{
  //   e.preventDefault();
  //   try{  
  //   let tempAddModalData = structuredClone(addModaldata)
  //   if(!tempAddModalData.roles){
  //     tempAddModalData =  {...tempAddModalData, "roles":["user"]} 
  //   }
  //   if(tempAddModalData.onDeputation === "No"){
  //     tempAddModalData =  {...tempAddModalData, "preDepOffice":null, "depRelivDate":null} 
  //   }
  //   const response = await addNewUser(tempAddModalData);
  //   console.log(response)
  //   setAddModalOpen(false);
  //   alert(`New User ${addModaldata.name} with emailID ${addModaldata.email} has been created successfully `)
  //   setAddModaldata({});
  //   }catch(err){}
  // }  


  // const handleDeleteClick = async (e,k,id) => {
  //   e.preventDefault();
  //   let body = {"id":id}
  //   const result = await deleteUser(body);
  //   console.log(result)
  // };  
  


  const handleSearchChange = (event, newValue, name ) =>{
    // let tempData = structuredClone(filterFunction(Object.values(users), Auth.roles));
    // let tempSearchData = structuredClone(searchData)
    // if(event?.target?.name){
    //   tempSearchData[event.target.name] = event.target.value;
    //   setSearchData(tempSearchData);
    //  }else{
    //   tempSearchData[name] = newValue
    //   setSearchData(tempSearchData);
    //  }
    // for(let key in tempSearchData){
    //   if(typeof tempSearchData[key] === "string" && tempSearchData[key].length){
    //       tempData = tempData.filter(x=> x[key]?.toLowerCase().includes(tempSearchData[key]?.toLowerCase()))
    //   }
    //   if (typeof tempSearchData[key] === "object" && tempSearchData[key].length){
    //     tempData = tempData.filter(x=> tempSearchData[key]?.map(x=>x.toLowerCase()).includes(x[key]?.toLowerCase()))
    //   }
    // }
    // console.log(tempData) 
    // setTabledata(tempData);
  }
  console.log(tabledata)
console.log(changeObj)

  useEffect(()=>{
    if(users){
      console.log("Entered")
      const userChangeArray = Object.values(userchanges);
      const filteredData = [];
      //  filterFunction(usersArray, Auth.roles);
      // let tempData = structuredClone(userChangeArray);
      // let tempSearchData = structuredClone(searchData); 
      // for(let key in tempSearchData){
      //   if(typeof tempSearchData[key] === "string" && tempSearchData[key].length){
      //     tempData = tempData.filter(x=> x[key]?.toLowerCase().includes(tempSearchData[key]?.toLowerCase()))
      //   }
      //   if (typeof tempSearchData[key] === "object" && tempSearchData[key].length){
      //   tempData = tempData.filter(x=> tempSearchData[key]?.map(x=>x.toLowerCase()).includes(x[key]?.toLowerCase()))
      //   }
      // }
    setTabledata(userChangeArray);
    }
  },[userchanges])

  useEffect(()=>{
    let finalDownloadData = [];
    let tempDownloadData = structuredClone(tabledata);
    for(let val of tempDownloadData ){
      let {_id, id, roles, password, timeStamp, refreshToken, ...others} = val;
      others = {...others, ["dob"]:moment(val.dob).format("DD-MM-YYYY"), ["doj"]:moment(val.doj).format("DD-MM-YYYY"), ["depRelivDate"]:val.onDeputation === "Yes"? moment(val.depRelivDate).format("DD-MM-YYYY"): "Not Applicable", ["presentPostingDate"]:moment(val.presentPostingDate).format("DD-MM-YYYY"), ["presentStationDate"]:moment(val.presentStationDate).format("DD-MM-YYYY")}
      finalDownloadData.push(others)
    }
    setDownloadData(finalDownloadData)
  }, [tabledata]) 

  const handlemodal = () =>{
    setOpen(true)
  }

  const handleDownloadNOC = () =>{

  }

   
  return (
    <>
    
    <Container>
      <HeadingWrap>
        <Span>User Changes</Span>
      </HeadingWrap>
      <form >
      <Box sx={{width: '98%', maxWidth: {
            md: '100%',  // for medium screens
          }}}>

    <ComplaintCategoryWrapper>
      <Button2Div>
          <ExcelDownload />
      </Button2Div>      

    </ComplaintCategoryWrapper>
    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead style={{backgroundColor: TableHeadStyle.backgroundColor }}>
        <TableRow>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont, width:{md:"5%"}}}>Sl.No.</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont, width:{md:"16.3%"}}}>Email Id</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont, width:{md:"16.3%"}}}>Name</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont, width:{md:"18%"}}} >Designation</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont, width:{md:"16.3%"}}}  >Office</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont, width:{md:"13%"}}} >Change Variables</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont, width:{md:"13%"}}} >Change Category</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont, width:{md:"13%"}}} >Time Stamp</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont}}>View Detail</TableCell>
          <TableCell align="left" style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{fontSize: tableCellFont}}>NOC</TableCell>

        </TableRow>
        <TableRow>
          <TableCell align="left" sx={{fontSize: tableCellFont}}></TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}}>
            <TextField  name='email' onChange={handleSearchChange} label="Search Email" size="small"  variant="outlined" sx={{backgroundColor:"white"}} />
          </TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}}>
            <TextField  name='name' onChange={handleSearchChange} label="Search Name" size="small"  variant="outlined" sx={{backgroundColor:"white"}} />
          </TableCell>

          <TableCell align="left" sx={{fontSize: tableCellFont}} >
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            onChange={(event, newValue) => handleSearchChange(event, newValue, "designation")}
            size="small"
            value={searchData.designation}
            options={designations?  Object.values(designations)?.map(x=>x.designation).sort():[] }
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ fontSize: '0.7rem' }}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 0, marginLeft:-20 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Search" placeholder="Roles" sx={{backgroundColor:"white"}} />
            )}
            /> 
            </TableCell>

            <TableCell align="left" sx={{fontSize: tableCellFont}} >
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "office")}
              size="small"
              value={searchData.office}
              options={offices?Object.values(offices)?.map(x=>x.name).sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '0.7rem' }} >
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:-20 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search" placeholder="Office" sx={{backgroundColor:"white"}} />
              )}
              /> 
          </TableCell>

          <TableCell align="left" sx={{fontSize: tableCellFont}} >
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "changeArray")}
              size="small"
              value={searchData.office}
              options={offices?Object.values(offices)?.map(x=>x.name).sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '0.7rem' }} >
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:-20 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search" placeholder="Change Variables" sx={{backgroundColor:"white"}} />
              )}
              /> 
          </TableCell>

          <TableCell align="left" sx={{fontSize: tableCellFont}} >
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "changeType")}
              size="small"
              value={searchData.office}
              options={offices?Object.values(offices)?.map(x=>x.name).sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '0.7rem' }} >
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:-20 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search" placeholder="Change Category" sx={{backgroundColor:"white"}} />
              )}
              /> 
          </TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}}>
          </TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}}>
          </TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}}>
          </TableCell>
          {/* <TableCell align="left" sx={{fontSize: tableCellFont}}></TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}}>
            <TextField  name='email' onChange={handleSearchChange} label="Search Email" size="small"  variant="outlined" />
          </TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}}>
            <TextField  name='name' onChange={handleSearchChange} label="Search Name" size="small"  variant="outlined" />
          </TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}} >
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            onChange={(event, newValue) => handleSearchChange(event, newValue, "designation")}
            size="small"
            value={searchData.designation}
            options={designations?  Object.values(designations)?.map(x=>x.designation).sort():[] }
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ fontSize: '0.7rem' }}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 0, marginLeft:-20 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Search" placeholder="Roles" />
            )}
            /> 
            </TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}} >
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "office")}
              size="small"
              value={searchData.office}
              options={offices?Object.values(offices)?.map(x=>x.name).sort():[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '0.7rem' }} >
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:-20 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search" placeholder="Office" />
              )}
              /> 
          </TableCell>
          <TableCell align="left" sx={{fontSize: tableCellFont}} >
          <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => handleSearchChange(event, newValue, "cadre")}
              size="small"
              value={searchData.cadre}
              options={cadreArray}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '0.7rem' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:-20 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Search" placeholder="Cadre" />
              )}
              /> 
          </TableCell>

          <TableCell align="left" sx={{fontSize: tableCellFont}}></TableCell> */}
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, k) => ( 
            <TableRow key={k} >
                <TableCell component="th" scope="row">
                {(page)*(rowsPerPage)+k+1}
                </TableCell>
                <TableCell  align="left" sx={{fontSize: tableCellFont}} >
                  {row?.email}
                </TableCell>

                <TableCell  align="left" sx={{fontSize: tableCellFont}} >
                  {nameStringFn(users[row.userId])}
                </TableCell>

                <TableCell  align="left" sx={{fontSize: tableCellFont}}>
                  {row?.designation[row?.office?.mainCharge]}
                </TableCell>

                <TableCell  align="left" sx={{fontSize: tableCellFont}}>
                  {row?.office?.mainCharge}
                </TableCell>

                <TableCell  align="left" sx={{fontSize: tableCellFont}}>
                  <Autocomplete              
                    size="small"
                    options={row.changeArray}
                    disableCloseOnSelect                           
                    renderInput={(params) => (
                      <TextField {...params} label="View Variables" placeholder="View Variables" />
                    )}
                  />                  
                </TableCell> 

                <TableCell  align="left" sx={{fontSize: tableCellFont}}>
                  {row?.changeType}
                </TableCell>

              <TableCell>{moment(row?.timeStamp).format('DD/MM/YYYY HH:mm')}</TableCell>


            <TableCell align="left"sx={{fontSize: tableCellFont}} >
              <button style={{marginRight:'10px'}} type="button"
                >View Detail
              </button>                                       
            </TableCell>

            <TableCell align="left"sx={{fontSize: tableCellFont}} >
              {row.changeType === "Relieving"? <DownloadIcon onClick={handleDownloadNOC} style={{color:"green"}} />:"NA"}                                  
            </TableCell>

          </TableRow>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </Box>
    </form>
    </Container>    
    </>
  );
}